export class FiltrosCPE{

    Tipo_Comprobante_CPE : string ='';    
    ClienteRuc : string = '';
    Serie : string = 'F002';
    NumeroFact : string = '';
    Estado : string ='A';
    Moneda : number = 0;
    Precio_Venta: number = 0;
 
 }